import service from '@/utils/server';

const modName='/bd/qc/';
//查询可操作开始采样的采样数据
export const pageInfo = data => {
  return service({
    url: modName + 'getStartQcPageInfo',
    method: 'post',
    data
  });
};

//开始采样
export const startQc = data => {
  return service({
    url: modName + 'startQc',
    method: 'post',
    data
  });
};






// WEBPACK FOOTER //
// ./src/page/bd/qc/start/api/index.js